/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { lAC_ITSGetCustomerCartAsync } from '../custom-actions/DataActionExtension.g';
import { ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/**
 * ITSGetEcomCart Input Action
 */
export class lAC_ITSGetCustomerCartInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public cartId: string;
    public customerId: string;

    constructor(cartId: string, customerId: string, authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.cartId = cartId;
        this.customerId = customerId;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ITSGETECOMCART_${this.cartId}`;
    public getCacheObjectType = () => 'ITSGETECOMCART';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

async function getEcomCartAsync(input: lAC_ITSGetCustomerCartInput, ctx: Msdyn365.IActionContext): Promise<Entities.Cart | undefined> {
    try {
        const result = await withFreshToken(ctx, input.authTokenCookie, async carried =>
            lAC_ITSGetCustomerCartAsync({ callerContext: ctx }, carried, input.cartId, input.customerId)
        );
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error getting ecom cart:', error);
        throw error;
    }

    return undefined;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Entities.Cart | undefined>>getEcomCartAsync,
    id: 'lAC_ITSGetCustomerCart'
});
